import ShowTable from "@/DocLayout/Table/index";
import { useLocales } from "@/locales";
import { CommonWrap } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box } from "@mui/material";

export default function CallProtocolRules() {
  const { translate, currentLang } = useLocales();
  return (
    <ContentWrap
      leftChildren={
        <CommonWrap>
          <>
            <Box component={"div"} className="title_0" id="rules-for-api-calls">
              {translate("faq.call_protocol_rules_title")}
            </Box>
            {currentLang.value !== "en" && (
              <Box component={"div"} className="desc">
                {translate("faq.call_protocol_rules_title_desc")}
              </Box>
            )}
          </>
          <ShowTable
            showName={false}
            showType={false}
            showRule={true}
            res={true}
            tableData={[
              {
                rule: translate("faq.call_protocol_rules_table_rule_desc1"),
                desc: translate("faq.call_protocol_rules_table_desc_desc1"),
              },
              {
                rule: translate("faq.call_protocol_rules_table_rule_desc2"),
                desc: translate("faq.call_protocol_rules_table_desc_desc2"),
              },
              {
                rule: translate("faq.call_protocol_rules_table_rule_desc3"),
                desc: translate("faq.call_protocol_rules_table_desc_desc3"),
              },
              {
                rule: translate("faq.call_protocol_rules_table_rule_desc4"),
                desc: translate("faq.call_protocol_rules_table_desc_desc4"),
              },
              {
                rule: translate("faq.call_protocol_rules_table_rule_desc5"),
                desc: translate("faq.call_protocol_rules_table_desc_desc5"),
              },
            ]}
          />
        </CommonWrap>
      }
    />
  );
}
